//import template from './Gallery.rt';
import { CommonItemContainer } from '../item/commonItemContainer.js'

import React from 'react'
import ReactDOM from 'react-dom'
import LoveButton from '../item/loveButton/loveButton.js'
import ItemLayout from '../item/itemLayout.js'
import Swipper from './swipper.js'
import BottomLink from './bottomLink.js';
import OldEditorNotice from './oldEditorNotice.js';
import FullscreenShareButtons from './fullscreenShareButtons.js';
import FullscreenSlider from './fullscreenSlider.js';
import FullscreenSocialDownload from './fullscreenSocialDownload.js';
import FullscreenDesktopNavbar from './fullscreenDesktopNavbar.js';
import FullscreenMobileBar from './fullscreenMobileBar.js';
import FullscreenSidebar from './fullscreenSidebar.js';
import FullscreenStoreBottomMobileBar from './fullscreenStoreBottomMobileBar.js';
import FullscreenShareScreen from './fullscreenShareScreen.js';
import { utils } from './../../utils';
import { versionManager } from '../../versioning/proGalleryVersionManager.js';
import cartApi from '../../store/cartApi';
import { storePubSub } from '../../store/applications/consts.js';

utils.fixViewport('Fullscreen');

class FullscreenView extends React.Component {

  constructor(props) {
    super(props);
    this.fullScreenCssCreated = false
    this.preloadeditems = [];

    this.toggleMobileBars = this.toggleMobileBars.bind(this);
    this.fadeToNextSlide = this.fadeToNextSlide.bind(this);
    this.navigateToPageByItemLink = this.navigateToPageByItemLink.bind(this);
    this.refreshCartItems = this.refreshCartItems.bind(this);

    this.state = {
      animating: false,
      pricingData: null,
      providerView: null,
      cartItems: []
    };

    if (utils.isStoreGallery()) {
      this.initializeCartItems();
    }
  }

  initializeCartItems() {
    Wix.PubSub.subscribe(storePubSub.refreshCart, () => {
      this.refreshCartItems();
    }, true)

    this.refreshCartItems();
  }

  refreshCartItems() {
    const galleryInfo = this.props.galleryInfo;
    if (galleryInfo && galleryInfo.connectedProviders) {
      const connectedProviderId = Object.keys(galleryInfo.connectedProviders)[0];
      cartApi.getCartItems(connectedProviderId).then(items => {
        this.setState({ cartItems: items });
      });
    }
  }

  //----------------------------------------------| Utils |----------------------------------------------//

  getItem(idx) {
    return this.props.items[idx] || {};
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  //--------------------------------------------| UI Actions |-------------------------------------------//

  fadeToNextSlide(direction) {

    if (direction != 0 && !this.state.animating) {
      utils.setStateAndLog(this, 'fadeToNextSlide animation start', {
        animating: true,
        direction: direction
      }, () => {
        setTimeout(() => {
          this.props.actions.next(direction); //triggers react after the animation is complete
          this.fixTransformForIos();
          utils.setStateAndLog(this, 'fadeToNextSlide animation complete', {
            animating: false,
            direction: 0
          }, this.fixTransformForIos);
        }, 400);
      });
    }

  }

  navigateToPageByItemLink(item) {
    if (item.linkType === 'wix') {
      Wix.navigateTo(item.linkData);
    } else {
      Wix.navigateToPage(item.linkUrl, { noTransition: true });
    }
  }

  toggleMobileBars(forceValueOrEvent) {
    if (versionManager.useFullscreenNewMobileLayout()) {
      return;
    }

    if (forceValueOrEvent === false) {
      $('.fullscreen-mobile-bar').addClass('hidden');
    } else if (forceValueOrEvent === true) {
      $('.fullscreen-mobile-bar').removeClass('hidden');
    } else {
      var elem = $(forceValueOrEvent.target);
      if (!(elem.children('video').length || elem.is('video') || elem.is('i') || elem.is('a') || elem.is('button'))) {
        // do not toggle bars if clicking a video
        $('.fullscreen-mobile-bar').toggleClass('hidden');
      }
    }
  }

  //-----------------------------------------| DOM Manipulation |----------------------------------------//

  fixLinkLineHeight() {

    var curItem = this.props.current.item;
    if (curItem.linkUrl && curItem.linkText) {

      //patch to limit link lines to 2

      var elem = $(ReactDOM.findDOMNode(this));
      if (!elem) return;

      var link = elem.find('.fullscreen-side-bar-exif.link');
      if (link.length != 1) {
        return;
      }
      var lineHeight = parseInt(link.css('line-height'));
      var numOfLines = 2;
      link.height(numOfLines * lineHeight);
      link.css({ '-webkit-line-clamp': (numOfLines + '') });
    }
  }

  fixTransformForIos() {
    if (utils.isiOS()) {
      $('.swipe-wrap .slide')
        .css('will-change', 'transform');
    }
  }

  fixSwiperContainerSizeIfNeeded(containerSize, prevContainerSize) {
    if (this.swipper && (containerSize.width !== prevContainerSize.width || containerSize.height !== prevContainerSize.height)) {
      this.swipper.setContainerSize(containerSize);
    }
  }

  //------------------------------------------| React methods |------------------------------------------//

  componentDidMount() {
    if (!utils.isStoreGallery() && utils.isTouch()) {
      this.swipper = new Swipper(this.props.actions.next, this.props.window.size);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.fixLinkLineHeight();
    this.fixTransformForIos();
    this.fixSwiperContainerSizeIfNeeded(this.props.window.size, prevProps.window.size);
  }

  handlePricingDataChganed(pricingData) {
    this.setState({ pricingData });
  }

  handleSetMobileData(type, data) {
    this.setState({ providerView: { type, data } });
  }

  handleProviderAction(type, data) {
    this.sidebar.postShopRequest(type, data);
  }

  handleAddToCartRequest() {
    const sidebar = this.sidebar;
    if (sidebar && (typeof sidebar.addToCartRequest === 'function')) {
      this.sidebar.addToCartRequest();
    }
  }

  render() {
    var isStoreGallery = utils.isStoreGallery()
    var isMobile = utils.isMobile()

    if (this.props.isNewEditor == false) {
      return <OldEditorNotice />
    }

    var curItem = this.props.current.item;

    var topMobileBar = <FullscreenMobileBar
        current={this.props.current}
        styleParams={this.props.styleParams}
        actions={this.props.actions}
        showInfo={this.props.showInfo}
        love={this.props.love}
        isFirst={true}
        showShareScreen={this.props.showShareScreen}
        />;

    var bottomMobileBar = versionManager.useFullscreenNewMobileLayout() ? false : (
      <FullscreenMobileBar
        current={this.props.current}
        styleParams={this.props.styleParams}
        actions={this.props.actions}
        showInfo={this.props.showInfo}
        love={this.props.love}
        isFirst={false}
        />
    );

    var sidebar =
      <FullscreenSidebar
        ref={element => this.sidebar = element}
        current={this.props.current}
        isSettings={this.props.isSettings}
        styleParams={this.props.styleParams}
        showInfo={this.props.showInfo}
        showShopFrame={this.props.showShopFrame}
        showMobileShopFrame={this.props.showMobileShopFrame}
        galleryId={this.props.galleryInfo && this.props.galleryInfo.galleryId ? this.props.galleryInfo.galleryId : ''}
        actions={_.merge(this.props.actions, {
          navigateToPageByItemLink: this.navigateToPageByItemLink
        })}
        onSetMobileData={(type, data) => this.handleSetMobileData(type, data)}
        providerView={this.state.providerView}
        onAddToCartRequest={() => this.handleAddToCartRequest()}
        connectedProviders={this.props.galleryInfo.connectedProviders}
        cartItems={this.state.cartItems}
    />

    var smallScreenArrows = (!versionManager.useFullscreenNewMobileLayout() && !this.props.showInfo && utils.isSmallScreen() && !utils.isTouch() && !this.props.showMobileShopFrame) ? [
      (<i
        className={"fullscreen-prev small-screen progallery-svg-font-icons-arrow_left " + (this.props.current.idx <= 0 ? ' fullscreen-icon-disabled ' : '')}
        onClick={() => this.fadeToNextSlide(-1)}
        key="small-screen-arrow-back"
        />),
      (<i
        className={"fullscreen-next small-screen progallery-svg-font-icons-arrow_right " + (this.props.current.idx >= (this.props.totalItems - 1) ? ' fullscreen-icon-disabled ' : '')}
        onClick={() => this.fadeToNextSlide(1)}
        key="small-screen-arrow-next"
        />)
    ] : '';

    var bottomLinkContainer = (this.props.current.item.hasLink && this.props.styleParams.allowLinkExpand) ? (
      <BottomLink
        current={this.props.current}
        actions={_.merge(this.props.actions, {
          navigateToPageByItemLink: this.navigateToPageByItemLink
        })}
        />
    ) : null

    var slider = (
      <FullscreenSlider
        items={this.props.items}
        current={this.props.current}
        window={this.props.window}
        styleParams={this.props.styleParams}
        animating={this.state.animating}
        direction={this.state.direction}
        totalItems={this.props.totalItems}
        isSettings={this.props.isSettings}
        love={this.props.love}
        actions={{
          toggleMobileBars: this.toggleMobileBars,
          fadeToNextSlide: this.fadeToNextSlide
        }}
        />
    );

    var desktopNavbar = (
      <FullscreenDesktopNavbar
        items={this.props.items}
        totalItems={this.props.totalItems}
        current={this.props.current}
        window={this.props.window}
        isSettings={this.props.isSettings}
        styleParams={this.props.styleParams}
        love={this.props.love}
        showInfo={this.props.showInfo}
        navigatedInto={this.props.navigatedInto}
        actions={_.merge(this.props.actions, {
          fadeToNextSlide: this.fadeToNextSlide
        })}
        />
    );

    if (utils.isVerbose()) { //todo yoshi
      console.timeEnd('Time in React');
      console.log("Render FullscreenView", this.props, this.state);
    }
    var storeBottomMobileBar = (utils.isMobile() && utils.isStoreGallery() ?
      <FullscreenStoreBottomMobileBar
        current={this.props.current}
        styleParams={this.props.styleParams}
        love={this.props.love}
        showInfo={this.props.showInfo}
        actions={_.merge(this.props.actions, {
          navigateToPageByItemLink: this.navigateToPageByItemLink
        })}
        showShopFrame={this.props.showShopFrame}
        showMobileShopFrame={this.props.showMobileShopFrame}
        showShareScreen={this.props.showShareScreen}
        galleryId={this.props.galleryInfo && this.props.galleryInfo.galleryId ? this.props.galleryInfo.galleryId : ''}
        providerView={this.state.providerView}
        onAddToCartRequest={() => this.handleAddToCartRequest()}
        onProviderAction={(type, data) => this.handleProviderAction(type, data)}
        cartItems={this.state.cartItems}

        /> : null
    )

    var fullscreenShareScreen =
      <FullscreenShareScreen
        current={this.props.current}
        styleParams={this.props.styleParams}
        showShareScreen={this.props.showShareScreen}
      />

    var clickAction = utils.getMobileEnabledClick(this.toggleMobileBars);
    const version = versionManager.getVersionFullscreenVersion();
    const versionClassName = version.toLowerCase();
    const expandedClassName = this.props.window.expanded ? ' expanded ' : '';
    const themeClassName = (utils.parseGetParam('theme') == 'dark' ? ' fullscreen-dark' : ' fullscreen-bright');
    const accessibilityClassName = (utils.isAccessibilityEnabled() ? ' accessible ' : '');
    const fullscreenClasses = `fullscreen inline-styles ${versionClassName} ${expandedClassName} ${themeClassName} ${accessibilityClassName}`;
    return (isStoreGallery && isMobile) ? (
      <div
        data-hook="fullscreen-view"
        id="fullscreen-view"
        className={fullscreenClasses}>
        {desktopNavbar}
        {topMobileBar}
        <div className="fullscreen-store-scroller">
          {sidebar}
          {bottomLinkContainer}
          <div style={{width: this.props.window.size.width, height: this.props.current.item.height, marginTop: 60}}>
            {slider}
          </div>
          {fullscreenShareScreen}
          {storeBottomMobileBar}
        </div>
      </div>
    ) : (
      <div
          {...clickAction}
        data-hook="fullscreen-view"
        id="fullscreen-view"
        className={fullscreenClasses}>
        {desktopNavbar}
        {topMobileBar}
        {sidebar}
        {bottomLinkContainer}
        {slider}
        {smallScreenArrows}
        {bottomMobileBar}
        {versionManager.useFullscreenNewMobileLayout() ? fullscreenShareScreen : false}
        {storeBottomMobileBar}
      </div>
    );
  }
}

export default CommonItemContainer(FullscreenView);



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenView.js